import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import { Avatar, Grid, Slide, Snackbar, SnackbarContent, useMediaQuery } from "@material-ui/core";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import moment from "moment-jalaali";
import {
  EarningChart,
  TodayPaymentsStatus,
  UnpaidTuitiones,
  LatestOrders,
  ReportBox,
  PayTutionDialog,
} from "./components";
import MoneyIcon from "@material-ui/icons/Money";
import PeopleIcon from "@material-ui/icons/PeopleOutlined";
import AssessmentIcon from "@material-ui/icons/Assessment";
import EventBusyIcon from "@material-ui/icons/EventBusy";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import ScheduleIcon from "@material-ui/icons/Schedule";
import { Snackbar_Contract } from "./components/Snackbar_Contract";
import theme from "theme";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  rootEmpty: {
    padding: 0,
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'));

  const [date, setDate] = useState(new Date());
  useEffect(() => {
    var timerID = setInterval(() => tick(), 1000);
    return function cleanup() {
      clearInterval(timerID);
    };
  });
  function tick() {
    setDate(new Date());
  }


  function TransitionUp(props) {
    return <Slide {...props} direction="up" />;
  }

  const [showAlert, setShowAlert] = useState(false);

  const [transition, setTransition] = React.useState(TransitionUp);

  const toggleAlert = () => {
    setShowAlert(!showAlert);
  };

  return (
    <div className={ isSmall?classes.rootEmpty: classes.root}>
      <PayTutionDialog onClose={toggleAlert} open={showAlert} />
      
      

      <Grid container spacing={4}>
        {/* <Grid item lg={4} sm={4} xl={4} xs={12}>
          <ReportBox
            icon={<Avatar 
            style={{borderRadius:0}}
              alt="all contract"
              src="/images/cargo.svg"
            />} 
            title="کل بارهای جاری"
            value={75}
            backColorIcon="#2196f3"
          />
        </Grid> */}
        {/* <Grid item lg={4} sm={4} xl={4} xs={12}>
          <ReportBox
            icon={<Avatar 
              style={{borderRadius:0}}
                alt="all contract"
                src="/images/group.svg"
              />}
            title="تعداد کارمندان"
            value={35}
            backColorIcon="#00bcd4"
          />
        </Grid> */}
        
        {/* <Grid item lg={4} sm={4} xl={4} xs={12}>
          <ReportBox
            icon={<Avatar 
              style={{borderRadius:0}}
                alt="all contract"
                src="/images/time.svg"
              />}
            title={moment(
              date.getFullYear() +
                "-" +
                date.getMonth() +
                1 +
                "-" +
                date.getDate()
            )
              .local("fa")
              .format("jYYYY/jM/jD")}
            value={date.toLocaleTimeString("en-US", { hour12: false })}
            // value={date.toLocaleDateString()}
            backColorIcon="#00bfa5"
          />
        </Grid> */}

        <Grid item lg={12} md={12} xl={12} xs={12}>
          <EarningChart />
        </Grid>
        {/* <Grid item lg={4} md={6} xl={3} xs={12}>
          <TodayPaymentsStatus />
        </Grid> */}
        {/* <Grid item lg={4} md={6} xl={3} xs={12}>
          <LatestOrders />
        </Grid>
        <Grid item lg={8} md={12} xl={9} xs={12}>
          <UnpaidTuitiones onSwitch={toggleAlert} />
        </Grid> */}
      </Grid>
    </div>
  );
};

export default Dashboard;
